import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: layout,
    component: layout,
    children: [
      {
        path: '/',
        redirect: '/home'
      },
      {
        path: '/home',
        name: 'home',
        component: (resolve) => require(['@/views/home/index.vue'], resolve)
      },
      {
        path: '/history',
        name: 'history',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: (resolve) => require(['@/views/history/index.vue'], resolve)
      },
      {
        path: '/collect',
        name: 'collect',
        component: (resolve) => require(['@/views/collect/index.vue'], resolve)
      },
      {
        path: '/ancient',
        name: 'ancient',
        component: (resolve) => require(['@/views/ancient/index.vue'], resolve)
      },
      {
        path: '/modern',
        name: 'modern',
        component: (resolve) => require(['@/views/modern/index.vue'], resolve)
      },
      {
        path: '/action',
        name: 'action',
        component: (resolve) => require(['@/views/action/index.vue'], resolve)
      },
      {
        path: '/joker',
        name: 'joker',
        component: (resolve) => require(['@/views/joker/index.vue'], resolve)
      },
      {
        path: '/account',
        name: 'account',
        component: (resolve) => require(['@/views/account/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: (resolve) => require(['@/views/userAgreement/index.vue'], resolve)
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: (resolve) => require(['@/views/privacyPolicy/index.vue'], resolve)
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
